<template>
  <div>
    <div class="text-center" v-show="isLoading">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <b-form v-show="!isLoading">
      <b-row>
        <b-col cols="12" md="12" class="my-2">
          <label> {{ $lang.taskUser.name }}: {{ name }}</label>
        </b-col>

        <b-col cols="12" md="12" class="my-2">
          <label>
            {{ $lang.explanation }}:
            <div v-html="description"></div
          ></label>
        </b-col>

        <b-col cols="12" md="12">
          <div v-for="(action, key) in actions" :key="key">
            <div v-if="action.params && action.type !== 'send_data'">
              <router-link
                :to="{ name: action.name, params: { ...action.params } }"
                >{{ action.caption }}</router-link
              >
            </div>
            <div v-if="action.type == 'send_data'">
              <button
                type="button"
                @click="sendInformationModal(action)"
                class="btn btn-primary"
              >
                ارسال اطلاعات
              </button>
            </div>
            <router-link v-else :to="{ name: action.name }">{{
              action.caption
            }}</router-link>
          </div>
        </b-col>

        <b-col cols="12" md="12" v-if="showUpload" class="mt-2">
          <uploadFile
            v-if="taskId"
            :keyServies="`task`"
            :parentPermissions="parentPermissions"
            :keyValue="taskId"
            :file_types="file_types"
            :showAdd="false"
          />
        </b-col>
        <b-col cols="12" md="12">
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="button"
              size="md"
              variant="success"
              @click="showConfirm"
            >
              {{ $lang.finishTask }}
              <i class="fa fa-check"></i>
            </b-button>
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="cancel"
            >
              {{ $lang.close }}
              <i class="fa fa-ban"></i>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>

    <confirm
      :title="modalTitle"
      :description="message"
      v-model="confirmModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="okConfim"
      @cancel="cancelConfim"
    ></confirm>
  </div>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import uploadFile from "@/components/base/uploadFile";
import editor from "@/components/ckeditor/editor";
import confirm from "@/components/base/confirm";

export default {
  validations: {
    userSelected: {
      required,
    },
    show_at: {
      required,
    },
    action: {
      required,
    },
    name: {
      required,
    },
    description: {
      required,
    },
  },
  name: "task-from",
  components: {
    uploadFile,
    confirm,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      defult: {},
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editor: "ClassicEditor",
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "maximize",
          "undo",
          "redo",
          "numberedList",
          "bulletedList",
          "simpleBox",
          "placeholder",
          "underline",
          "fontSize",
        ],
        placeholderConfig: {
          types: ["date", "color", "first name", "surname"], // ADDED
        },
        fontSize: {
          options: [10, 12, 14, "default", 18, 20, 22],
        },
        language: {
          // language: fa,
          // The UI will be fa.
          ui: "fa",
          // But the content will be edited in fa.
          content: "fa",
        },
      },
      file_types: ["image", "office", "media", "other"],

      user_options: [],
      userSelected: null,
      show_at: null,
      action: null,
      name: null,
      description: null,
      taskId: null,
      finishTask: 0,
      confirmModal: false, // بازکردن مدال کانفرم
      modalTitle: "", // عنوان مدال
      message: "", // نمایش متن حذف فایل,
    };
  },
  methods: {
    sendInformationModal(action) {
      let payload = {
        actionResource: action.resource,
        actionkey: action.key,
        modal: true,
      };
      this.$emit("openModal", payload);

      // this.sendFileModal = !this.sendFileModal
    },

    /**
     * @vuese
     * پاک کردن پیغام تایید پاک کردن
     *  @arg  بدون پارامتر
     */
    clearModalConfirm() {
      this.modalTitle = "";
    },
    /**
     * @vuese
     * قبول کردن فایل حذف شود
     *  @arg  بدون پارامتر
     */
    async okConfim() {
      this.filesLoading = true;
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let payload = {
        user_code: this.userSelected && this.userSelected.code,
        show_at: this.show_at,
        action: this.action,
        name: this.name,
        description: this.description,
        finishTask: this.finishTask,
      };
      this.$emit("submit", payload);
      this.clearModalConfirm();
    },
    /**
     * @vuese
     * لغو کردن فایل حذف شود
     *  @arg  بدون پارامتر
     */
    cancelConfim() {
      this.confirmModal = false;
      this.clearModalConfirm();
    },
    cancel() {
      this.$emit("modal-end-up", false);
    },
    getUser(query) {
      if (!query || query.length < 3) {
        this.user_options = [];
        return;
      }
      this.$httpService
        .get(
          this.$config.api_url +
            this.$config.resources.user +
            "?search_txt=" +
            query
        )
        .then((response) => {
          let user = response.data.data.result.map((x) => {
            x.name = x.person.name;
            return x;
          });
          this.user_options = user;
        })
        .catch((err) => {
          this.user_options = [];
        });
    },
    showConfirm() {
      this.confirmModal = true;
      this.modalTitle = this.$lang.finishTask;
      this.message = this.$lang.finish_task_tooltip;
    },

    fetchData() {
      if (this.item && Object.keys(this.item).length > 0) {
        if (this.item.user) {
          let user = {
            name: this.item.user.name + " " + this.item.user.family,
            code: this.item.user.code,
          };
          this.userSelected = user;
        }
        (this.show_at = this.item.show_at && this.item.show_at.jalali),
          (this.action = this.item.action),
          (this.name = this.item.name),
          (this.description = this.item.description);
        this.taskId = this.item.id.toString();
      }
    },
  },
  watch: {
    userSelected() {},
  },
  created() {
    this.fetchData();
  },
};
</script>
